/**
 * @ngdoc type
 * @name NavigationManager
 * @module mx.sb.Navigation
 *
 * @property {string} avatar - Read-only. Gets user profile avatar's url obtained from profile service.
 * @property {string} firstName - Read-only. Gets user first name obtained from profile service.
 * @property {string} lastName - Read-only. Gets user last name obtained from profile service.
 * @property {boolean} collapsedState - Control and reflect current navigation state: extended or collapsed.
 *
 * @description
 * A factory that produces Navigation Manager object that is used to manage the visibility of a side panel.
 */
import { UserProfileService } from '../../App/services/user-profile-service';
import { EventService } from '../../App/services/event-service';
import { EventCodes } from '../../App/model/event-codes';
import { UserProfile } from '../../App/model/user-profile';
import { NavigationItem } from './model/navigation-item';

export class NavigationManager {
	public static $inject = ['mx.shell.UserProfileService', 'mx.shell.EventService'];
	public collapsedMode = false;
	public filterText = '';

	public avatar: UserProfile['avatar'] | null = null;
	public firstName: UserProfile['firstName'] | null = null;
	public lastName: UserProfile['lastName'] | null = null;
	public email: UserProfile['email'] | null = null;

	constructor(private readonly userProfileService: UserProfileService, private readonly eventService: EventService) {
		this.collapsedMode = localStorage && localStorage.getItem('mxShellNavCollapsedMode') === 'true';

		userProfileService.get().then((profile) => {
			this.setUserInfo(profile);

			this.eventService.subscribeGlobal(EventCodes.ProfileChanged, (event, profile: UserProfile) => this.setUserInfo(profile));
		});
	}

	/**
	 	Be very careful - it's very performance-expensive method
	 */
	public filterNavTree(item: NavigationItem) {
		return item.matchesFilterCriteria !== false;
	}

	private setUserInfo(profile: UserProfile): void {
		this.avatar = profile ? profile.avatar : null;
		this.firstName = profile ? profile.firstName : null;
		this.lastName = profile ? profile.lastName : null;
		this.email = profile ? profile.email : null;
	}
}
